<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>

  <form class="form" [formGroup]="immunizationEditForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>

      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.details | translate }}</li>
        </ul>
      </kt-alert>

      <div class="form-group row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'IMMUNIZATION.INPUT.BASIC' | translate }}</h4>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding: 5px 30px 30px 30px">
          <div class="row">
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.VACCINE_CODE">Vaccine code</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoVaccine"
                  (ngModelChange)="vaccineInputChanged(vaccineInput.value)"
                  #vaccineInput
                  formControlName="vaccine"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoVaccine="matAutocomplete"
                  (optionSelected)="selectedVaccine($event)"
                  [displayWith]="displayFnVaccine"
                >
                  <!--   -->
                  <mat-option *ngFor="let vaccine of filteredVaccine | async" [value]="vaccine">
                    {{ vaccine.concept.fsn.term }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('vaccine', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.STATUS">Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option value="completed">Completed</mat-option>
                  <mat-option value="entered-in-error">Entered in error</mat-option>
                  <mat-option value="not-done">Not done</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('status', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.STATUS_REASON">Status reason</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoReason"
                  (ngModelChange)="reasonInputChanged(reasonInput.value)"
                  #reasonInput
                  formControlName="statusReason"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoReason="matAutocomplete"
                  (optionSelected)="selectedReason($event)"
                >
                  <!--  [displayWith]="displayFnReason" -->
                  <mat-option *ngFor="let reason of filteredReason | async" [value]="reason">
                    {{ reason.concept.fsn.term }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('statusReason', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.OCCURRENCE' | translate }}</mat-label>
                <input matInput [matDatepicker]="occurrence" formControlName="occurrence" />
                <mat-datepicker-toggle matSuffix [for]="occurrence"></mat-datepicker-toggle>
                <mat-datepicker #occurrence></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.RECORDED_DATE' | translate }}</mat-label>
                <input matInput [matDatepicker]="recordedDate" formControlName="recordedDate" />
                <mat-datepicker-toggle matSuffix [for]="recordedDate"></mat-datepicker-toggle>
                <mat-datepicker #recordedDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.NOTE' | translate }}</mat-label>
                <textarea matInput formControlName="note" rows="4"></textarea>
                <mat-error *ngIf="isControlHasError('note', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 20px">
              <mat-label class="label-radio-button" translate="IMMUNIZATION.INPUT.SITE"
                >Site</mat-label
              >

              <mat-radio-group formControlName="site">
                <mat-radio-button *ngFor="let res of sites" [value]="res">{{
                  res.display
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <br />
            <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 15px">
              <div class="checkbox-list">
                <label class="checkbox">
                  <input type="checkbox" formControlName="primarySource" />
                  <span></span>
                  {{ 'IMMUNIZATION.INPUT.PRIMARY_SOURCE' | translate }}
                </label>
              </div>
            </div>
            <br />
            <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 15px">
              <div class="checkbox-list">
                <label class="checkbox">
                  <input type="checkbox" formControlName="isSubpotent" />
                  <span></span>
                  {{ 'IMMUNIZATION.INPUT.IS_SUBPOTENT' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'IMMUNIZATION.INPUT.EDUCATION' | translate }}</h4>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding: 5px 30px 30px 30px">
          <div class="row">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.DOC_TYPE' | translate }}</mat-label>
                <input matInput formControlName="documentType" />
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.REFERENCE' | translate }}</mat-label>
                <input matInput formControlName="reference" />
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.PUBLICATION_DATE' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="publicationDate"
                  formControlName="publicationDate"
                />
                <mat-datepicker-toggle matSuffix [for]="publicationDate"></mat-datepicker-toggle>
                <mat-datepicker #publicationDate></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.PRESENTATION_DATE' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="presentationDate"
                  formControlName="presentationDate"
                />
                <mat-datepicker-toggle matSuffix [for]="presentationDate"></mat-datepicker-toggle>
                <mat-datepicker #presentationDate></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'IMMUNIZATION.INPUT.PERFORMER' | translate }}</h4>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding: 5px 30px 30px 30px">
          <div class="row">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.ACTOR_TYPE">Actor Type</mat-label>
                <mat-select
                  formControlName="actorType"
                  #ts
                  (ngModelChange)="chooseActorType(ts.value)"
                >
                  <mat-option value="Practitioner">Practitioner</mat-option>
                  <mat-option value="PractitionerRole">Practitioner role</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('actorType', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile" *ngIf="actorOption === 'Practitioner'">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.ACTOR">Actor</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoActor"
                  (ngModelChange)="actorInputChanged($event, ts.value)"
                  #actorInput
                  formControlName="actor1"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoActor="matAutocomplete"
                  (optionSelected)="selectedActor($event)"
                  [displayWith]="displayFnActor"
                >
                  <mat-option *ngFor="let actor of filteredActor | async" [value]="actor">
                    {{ actor.first_name }} {{ actor.last_name }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('actor1', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div
              class="col-lg-6 kt-margin-bottom-20-mobile"
              *ngIf="actorOption === 'PractitionerRole'"
            >
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.ACTOR">Actor</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoActor"
                  (ngModelChange)="actorInputChanged($event, ts.value)"
                  #actorInput2
                  formControlName="actor2"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoActor="matAutocomplete"
                  (optionSelected)="selectedPra($event)"
                  [displayWith]="displayFnPra"
                >
                  <mat-option *ngFor="let actor of filteredPractitionerRole" [value]="actor">
                    {{ actor.specialty[0].coding[0].display }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('actor2', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-8 kt-margin-bottom-20-mobile">
              <mat-label class="label-radio-button" translate="IMMUNIZATION.INPUT.FUNCTION"
                >Function</mat-label
              >

              <mat-radio-group formControlName="function">
                <mat-radio-button *ngFor="let res of functions" [value]="res">{{
                  res.display
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'IMMUNIZATION.INPUT.PROTOCOL_APPLIED' | translate }}</h4>
        </div>

        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding: 5px 30px 30px 30px">
          <div class="row">
            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.SERIES' | translate }}</mat-label>
                <input matInput formControlName="series" />
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.TARGET_DISEASE">Target Disease</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoTargetDisease"
                  (ngModelChange)="targetDiseaseInputChanged(targetDiseaseInput.value)"
                  #targetDiseaseInput
                  formControlName="targetDisease"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoTargetDisease="matAutocomplete"
                  (optionSelected)="selectedTargetDisease($event)"
                >
                  <!--  [displayWith]="displayFnTargetDisease" -->
                  <mat-option
                    *ngFor="let targetDisease of filteredTargetDisease | async"
                    [value]="targetDisease"
                  >
                    {{ targetDisease.concept.fsn.term }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('targetDisease', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.DOSE_NUMBER' | translate }}</mat-label>
                <input matInput type="number" formControlName="doseNumber" />
              </mat-form-field>
            </div>

            <div class="col-lg-6 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.SERIESDOSES' | translate }}</mat-label>
                <input matInput type="number" formControlName="seriesDoses" />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <h4>{{ 'IMMUNIZATION.INPUT.OTHER' | translate }}</h4>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding: 5px 30px 30px 30px">
          <div class="row">
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.REASON_CODE">Reason code</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoReasonCode"
                  (ngModelChange)="reasonCodeInputChanged(reasonCodeInput.value)"
                  #reasonCodeInput
                  formControlName="reasonCode"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoReasonCode="matAutocomplete"
                  (optionSelected)="selectedReasonCode($event)"
                >
                  <!--  [displayWith]="displayFnReason" -->
                  <mat-option
                    *ngFor="let reasonCode of filteredReasonCode | async"
                    [value]="reasonCode"
                  >
                    {{ reasonCode.concept.fsn.term }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('reasonCode', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.SUBPOTENTREASON"
                  >Subpotent reason</mat-label
                >
                <mat-select formControlName="subpotentReason">
                  <mat-option *ngFor="let res of subpotentReasons" [value]="res">{{
                    res.display
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('subpotentReason', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.CONDITION">Condition</mat-label>
                <input
                  matInput
                  [matAutocomplete]="autoCondition"
                  (ngModelChange)="conditionInputChanged(conditionInput.value)"
                  #conditionInput
                  formControlName="conditionSearch"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoCondition="matAutocomplete"
                  (optionSelected)="selectedCondition($event)"
                  [displayWith]="displayFnCondition"
                >
                  <mat-option *ngFor="let condition of filteredCondition" [value]="condition">
                    {{ condition.code.coding[0].display }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isControlHasError('conditionSearch', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label translate="IMMUNIZATION.INPUT.REPORT_ORIGIN">Origin report</mat-label>
                <mat-select formControlName="reportOrigin">
                  <mat-option *ngFor="let res of reportOrigins" [value]="res">{{
                    res.display
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('reportOrigin', 'required')">
                  {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.ROUTE' | translate }}</mat-label>
                <mat-select formControlName="route">
                  <mat-option *ngFor="let res of routes" [value]="res">{{
                    res.display
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.EXPIRATION_DATE' | translate }}</mat-label>
                <input matInput [matDatepicker]="expirationDate" formControlName="expirationDate" />
                <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
                <mat-datepicker #expirationDate></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.LOT_NUMBER' | translate }}</mat-label>
                <input matInput type="number" formControlName="lotNumber" />
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.DOSE_QUANT_VALUE' | translate }}</mat-label>
                <input matInput type="number" formControlName="doseQuantityValue" />
              </mat-form-field>
            </div>

            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'IMMUNIZATION.INPUT.DOSE_QUANT_UNIT' | translate }}</mat-label>
                <input matInput formControlName="doseQuantityUnit" />
              </mat-form-field>
            </div>

            <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 20px">
              <mat-label class="label-radio-button" translate="IMMUNIZATION.INPUT.FUNDING_SOURCE"
                >Funding Source
              </mat-label>
              <mat-radio-group formControlName="fundingSource">
                <mat-radio-button *ngFor="let res of fundingSources" [value]="res">{{
                  res.display
                }}</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <mat-label
                class="label-radio-button"
                translate="IMMUNIZATION.INPUT.PROGRAM_ELIGIBILITY"
                >Program Eligibility
              </mat-label>

              <mat-radio-group formControlName="programEligibility">
                <mat-radio-button *ngFor="let res of programEligibilitys" [value]="res">{{
                  res.display
                }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            *ngIf="!isReadOnly"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
